import {graphql} from 'gatsby'
import React from 'react'

import useSignup from '@/hooks/use-signup'

import type {Props as SimpleSignupFormProps} from './signup-banner-base'
import type {TextProps} from '@/components/text'
import type {Args as UseSignupArgs} from '@/hooks/use-signup'
import type {FormConfig} from '@/types/consents'
import type {ImageSource} from '@/types/image'
import type {BackgroundColor} from '@/utils/is-valid-background-color'

import SignupBannerBase from './signup-banner-base'

export interface Props
    extends Pick<
        SimpleSignupFormProps,
        'placeholder' | 'submitText' | 'errorText' | 'stacked' | 'ariaLabel'
    > {
    color: BackgroundColor
    title: string
    subtitle: string
    formConfig: FormConfig
    image?: ImageSource | null
    titleVariant?: TextProps['$variant']
    signupOptions?: UseSignupArgs
    dataTestId?: string
}

const SignupBanner = React.forwardRef<HTMLDivElement, Props>(
    ({signupOptions, formConfig, ...props}, ref) => {
        const signupProps = useSignup(
            signupOptions || {
                form: 'Front',
            },
            formConfig.formId,
        )

        return <SignupBannerBase ref={ref} {...props} {...signupProps} />
    },
)

export const signupBannerFragment = graphql`
    fragment SignupBanner on PrismicSignupBanner {
        _previewable
        type
        data {
            title
            subtitle
            email_input_placeholder
            email_input_error_text
            submit_text
            aria_label
            image {
                alt
                copyright
                url
                dimensions {
                    width
                    height
                }
            }
            redirect_link {
                ...PrismicLink
            }
            partner_signup_redirect
            form_name
            form_production {
                formId
                consents {
                    type
                    communicationConsents {
                        id
                        required
                    }
                }
            }
            form_staging {
                formId
                consents {
                    type
                    communicationConsents {
                        id
                        required
                    }
                }
            }
        }
    }
`

export default SignupBanner
